import StvPage from "./ctx-provider/StvPage";
import useAppCtx from "./ctx-provider/useAppCtx";


export interface UnauthorizedF {
    (): void
}


const useUnauthorized = () => {
    const { appCtxBo, setAppCtxBo } = useAppCtx();

    const handleUnauthorized = () => {
        appCtxBo.currentPage = StvPage.SESSION_INVALID;
        setAppCtxBo(appCtxBo);
    }

    return { handleUnauthorized };
}

export default useUnauthorized